/* eslint-disable react/jsx-key */
import EfImg from '@elem/ui/ef-img';
import { FC, useLayoutEffect, useState } from 'react';
import css from './index.module.scss';

const VS: FC = () => {
    const [isH5, setIsH5] = useState(false);

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1738723355353/DELTA%203%20Plus%20(4).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737787354305/DELTA%203%20Plus%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1737787370254/DELTA%203%20Plus%20(2).png',
            title: 'DELTA 3 Plus',
            label: 'Family Camping Power Hub',
            netWeight: '12.5kg',
            dimension: '398 x 202 x 284 mm',
            capacity: '1024 Wh（85Ah@12V）',
            output: [
                { label: 'AC Output', text: '4 outlets, 1800W total, X-boost 2400W (Surge 3600W)' },
                { label: 'USB-A Output', text: '2 ports, 36W' },
                { label: 'USB-C Output', text: '140W' },
            ],
            input: [
                { label: 'AC Charging', text: '1500W' },
                { label: 'Solar Charging', text: '1000W' },
            ],
            ups: '10ms',
            noise: '30dB',
            life: '4000 cycles to 80+% capacity',
            warranty: '5 years',
            lifestage: 'Family Weekend Escape Companion',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736935532172/DELTA%202.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736911222993/DELTA%202%20(6).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1737683987261/DELTA%202.png',
            title: 'DELTA 2',
            label: 'Classic choice',
            netWeight: '12kg',
            dimension: '400 x 211 x 281 mm',
            capacity: '1024 Wh（85Ah@12V）',
            output: [
                { label: 'AC Output', text: '4 outlets, 1800W total, X-boost 2200W (Surge 2700W)' },
                { label: 'USB-A Output', text: '4 ports, 18W' },
                { label: 'USB-C Output', text: '100W' },
            ],
            input: [
                { label: 'AC Charging', text: '1200W' },
                { label: 'Solar Charging', text: '500W' },
            ],
            ups: '30ms',
            noise: '-',
            life: '3000 cycles to 80+% capacity',
            warranty: '5 years',
            lifestage: '/',
        },
    ];
    const handleResize = () => {
        if (typeof window === 'undefined') return;
        setIsH5(() => window.innerWidth < 768);
    };
    useLayoutEffect(() => {
        if (typeof window === 'undefined') return;
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const list = ['Net Weight', 'Dimension', 'Capacity', 'Output', 'Input', 'UPS', 'Noise', 'Cycle Life', 'Warranty', 'Lifestage'];
    return (
        <div className={`${css.thecomp}`}>
            <div className="thecomp-item">
                {items.map((item, idx) => {
                    return (
                        <div className={`vs-item item-${idx + 1}`} key={item.label}>
                            <p className={`vs-item-title vs-item-title-${idx + 1}`}>{item.title}</p>
                            <div className="vs-item-img">
                                {item.pc && <EfImg pc={item.pc} pad={item?.pad} h5={item.h5} />}
                                {idx === 0 && <p className="vs-item-img-new">NEW</p>}
                            </div>
                            <ul className={`vs-item-content vs-item-content-${idx + 1}`}>
                                {!isH5 ? (
                                    <li>{item.netWeight}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Net Weight</div>
                                        <div className="li-2">{item.netWeight}</div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li>{item.dimension}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Dimension</div>
                                        <div className="li-2">{item.dimension}</div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li>{item.capacity}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Capacity</div>
                                        <div className="li-2">{item.capacity}</div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li className="vs-item-list-output">
                                        {item?.output?.map((j, itemIdx) => (
                                            <div className="vs-item-list-output-item">
                                                <span className="title">{`${j.label} : `}</span>
                                                {itemIdx === 0 ? <br></br> : ''}
                                                <span className="desc">{j.text}</span>
                                            </div>
                                        ))}
                                    </li>
                                ) : (
                                    <li className="vs-item-list-output">
                                        <div className="li-1">Output</div>
                                        <div className="vs-item-list-output li-2">
                                            {item?.output?.map((j, itemIdx) => (
                                                <div className="vs-item-list-output-item">
                                                    <span className="title">{`${j.label} : `}</span>
                                                    {itemIdx === 1 ? <br></br> : ''}
                                                    <span className="desc">{j.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li key={idx} className="vs-item-list-input">
                                        {item?.input?.map((j, idx) => (
                                            <div>
                                                <span className="title">{`${j.label} : `}</span>
                                                <span className="desc">{j.text}</span>
                                            </div>
                                        ))}
                                    </li>
                                ) : (
                                    <li>
                                        <div className="li-1">Input</div>
                                        <div key={idx} className="vs-item-list-input li-2">
                                            {item?.input?.map((j, idx) => (
                                                <div>
                                                    <span className="title">{`${j.label} : `}</span>
                                                    <span className="desc">{j.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li>{item.ups}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">USP</div>
                                        <div className="li-2">{item.ups}</div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li>{item.noise}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Noise</div>
                                        <div className="li-2">{item.noise}</div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li>{item.life}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Cycle Life</div>
                                        <div className="li-2">{item.life}</div>
                                    </li>
                                )}
                                <span className="vs-item-border"></span>
                                {!isH5 ? (
                                    <li>{item.warranty}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Warranty</div>
                                        <div className="li-2">{item.warranty}</div>
                                    </li>
                                )}
                                {!isH5 ? (
                                    <li>{item.lifestage}</li>
                                ) : (
                                    <li>
                                        <div className="li-1">Lifestage</div>
                                        <div className="li-2">{item.lifestage}</div>
                                    </li>
                                )}
                                <div className="vs-item-img-text">
                                    <p>{item.label}</p>
                                </div>
                            </ul>
                        </div>
                    );
                })}
            </div>

            {!isH5 && (
                <ul className="list-content">
                    {list.map((item, idx) => {
                        return <li>{item}</li>;
                    })}
                </ul>
            )}
        </div>
    );
};

export default VS;
